import React from 'react';
import styles from 'src/components/ItemMask/itemMask.module.scss';

export default function ItemMask() {
  return <div className={styles.mask}></div>;
}
